function hexTo32Bytes(hex) {
    const clean = hex.replace(/^0x/i, '');
    if (clean.length !== 64){
        throw new Error('TON address must be 32-byte hex');
    }
    const out = new Uint8Array(32);
    for (let i = 0; i < 32; i++){
        out[i] = parseInt(clean.slice(i * 2, i * 2 + 2), 16);
    }
    return out;
}

function crc16Xmodem(bytes) {
    let crc = 0x0000;
    for (let b of bytes) {
        crc ^= b << 8;
        for (let i = 0; i < 8; i++) {
            crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : (crc << 1) & 0xffff;
        }
    }
    return crc & 0xffff;
}

function base64Url(bytes) {
    let bin = '';
    for (let i = 0; i < bytes.length; i++){
        bin += String.fromCharCode(bytes[i]);
    }
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

/**
 * toFriendlyTon
 * @param {string} input raw "0:<64hex>" або "-1:<64hex>" чи вже friendly
 * @param {{ testOnly?: boolean, bounceable?: boolean }} opts
 * @returns {string} friendly (base64url)
 */

export function toFriendlyTon(input, { testOnly = false, bounceable = true } = {}) {
    if (!input){
        return '';
    }
    const s = String(input).trim();

    if (/^[A-Za-z0-9\-_]{48,}$/.test(s) && !s.includes(':')) {
        return s.replace(/=+$/g, '');
    }

    const m = s.match(/^(-?\d+):([0-9a-fA-F]{64})$/);
    if (!m){
        return s;    
    }

    const wc = parseInt(m[1], 10);
    if (!(wc === 0 || wc === -1)){
        throw new Error('Unsupported workchain (only 0 or -1)');
    }
    const addr = hexTo32Bytes(m[2]);

    let tag = bounceable ? 0x11 : 0x51;
    if (testOnly){
        tag |= 0x80;
    }

    const body = new Uint8Array(34);
    body[0] = tag;
    body[1] = wc === -1 ? 0xff : 0x00;
    body.set(addr, 2);

    const crc = crc16Xmodem(body);
    const out = new Uint8Array(36);
    out.set(body, 0);
    out[34] = (crc >> 8) & 0xff;
    out[35] = crc & 0xff;

    return base64Url(out);
}
